module.exports = __webpack_public_path__ + "a814c1b6e89dc1a6c25c0badaf2711d4.png";